export default __webpack_public_path__ + "static/superstructure_b.395425f7146745e4781426eec7176b00.png";